// extracted by mini-css-extract-plugin
module.exports = {"catagory-card":"CatagoricalCard_catagory-card__3u1Gm","all":"CatagoricalCard_all__1VY_X"};